import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { CityImprovementTypes, PlayerColor } from '@colonist/game-states';
import { EnumUtils } from '@colonist/utils';
export class UIGameMetropolisAchievementController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.CityImprovementStateUpdated:
                this.playerReceivedMetropolis();
                break;
            default:
                break;
        }
    }
    playerReceivedMetropolis() {
        const metropolisType = this.getUpdatedMetropolisType();
        if (metropolisType == undefined) return;
        const achievementType = UIGameMetropolisAchievementController.getAchievementType(metropolisType);
        const achievement = {
            achievementOwnerNew: this.uiGameManager.gameController.currentState.currentTurnPlayerColor,
            achievementOwnerPrevious: this.metropolisOwners.get(metropolisType),
            achievementType: achievementType
        };
        this.metropolisOwners.set(metropolisType, achievement.achievementOwnerNew);
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement);
    }
    // eslint-disable-next-line colonist/camelcase-union-values -- achievement type keys
    static getAchievementType(metropolisType) {
        switch(metropolisType){
            case CityImprovementTypes.Trade:
                return 'MetropolisTrade';
            case CityImprovementTypes.Politics:
                return 'MetropolisPolitics';
            case CityImprovementTypes.Science:
                return 'MetropolisScience';
        }
    }
    initMetropolisOwners() {
        this.metropolisOwners = new Map();
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType)=>{
            var _this_cityImprovementsValidator_getPlayerColorOfMetropolisOwner;
            this.metropolisOwners.set(cityImprovementType, (_this_cityImprovementsValidator_getPlayerColorOfMetropolisOwner = this.cityImprovementsValidator.getPlayerColorOfMetropolisOwner(cityImprovementType)) !== null && _this_cityImprovementsValidator_getPlayerColorOfMetropolisOwner !== void 0 ? _this_cityImprovementsValidator_getPlayerColorOfMetropolisOwner : PlayerColor.None);
        });
    }
    getUpdatedMetropolisType() {
        let updatedCityImprovementType;
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType)=>{
            for (const player of this.uiGameManager.gameController.getPlayerColors()){
                const playerDidntHaveMetropolisBefore = this.metropolisOwners.get(cityImprovementType) != player;
                const playerHasMetropolis = this.cityImprovementsValidator.getPlayerCityImprovementsStateForType(player, cityImprovementType).hasMetropolis;
                if (playerHasMetropolis && playerDidntHaveMetropolisBefore) updatedCityImprovementType = cityImprovementType;
            }
        });
        return updatedCityImprovementType;
    }
    constructor(uiGameManager, cityImprovementsValidator){
        this.uiGameManager = uiGameManager;
        this.cityImprovementsValidator = cityImprovementsValidator;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.initMetropolisOwners();
    }
}
